import * as React from 'react';
import classNames from 'classnames';

export default function BulletinBoard(props) {
    const { className, ...others } = props;
    return (
        <svg
            className={classNames('icon', className)}
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            {...others}
        >
            <path
                d="M2 4.91667C2 3.30556 3.30556 2 4.91667 2H19.0833C20.6944 2 22 3.30556 22 4.91667V19.0833C22 20.6944 20.6944 22 19.0833 22H4.91667C4.14312 22 3.40125 21.6927 2.85427 21.1457C2.30729 20.5987 2 19.8569 2 19.0833V4.91667ZM20.6111 14.7778V9.5H15.0556V14.7778H20.6111ZM15.0556 16.1667V20.6111H19.0833C19.4885 20.6111 19.8771 20.4501 20.1636 20.1636C20.4501 19.8771 20.6111 19.4885 20.6111 19.0833V16.1667H15.0556ZM13.6667 12.8333H3.38889V19.0833C3.38889 19.4885 3.54985 19.8771 3.83636 20.1636C4.12288 20.4501 4.51147 20.6111 4.91667 20.6111H13.6667V12.8333ZM13.6667 11.4444V3.38889H4.91667C4.51147 3.38889 4.12288 3.54985 3.83636 3.83636C3.54985 4.12288 3.38889 4.51147 3.38889 4.91667V11.4444H13.6667ZM20.6111 8.11111V4.91667C20.6111 4.51147 20.4501 4.12288 20.1636 3.83636C19.8771 3.54985 19.4885 3.38889 19.0833 3.38889H15.0556V8.11111H20.6111Z"
                fill="currentColor"
            />
        </svg>
    );
}
